import React, { FC } from 'react';
import { IonPage } from '@ionic/react';

export interface AlliePageContainerProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

/**
 * AlliePageContainer - Wrapper around IonPage
 * Provides consistent page container styling and behavior
 */
export const AlliePageContainer: FC<AlliePageContainerProps> = ({ children, className, id }) => {
  return (
    <IonPage className={className} id={id}>
      {children}
    </IonPage>
  );
};

AlliePageContainer.displayName = 'AlliePageContainer';
